import { Component, HostBinding, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ModalDismissRoleEnum } from 'src/app/task-process/answer-editor/send-and-popover/modal-dismiss-role.enum';

import { BasicService } from '../../services/basic.service';
import { DatetimeIonicPopoverComponent } from './datetime-ionic-popover/datetime-ionic-popover.component';

/**
 * To be used when upgrading to Ionic v6
 */
@Component({
  selector: 'app-datetime-ionic',
  templateUrl: './datetime-ionic.component.html',
  styleUrls: ['./datetime-ionic.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DatetimeIonicComponent,
    },
  ],
})
export class DatetimeIonicComponent implements ControlValueAccessor {
  @Input() withTime: boolean;

  @HostBinding('class.disabled') disabled = false;

  value: string;

  private touched = false;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onChange = (value: string) => {};
  private onTouched = () => {};

  constructor(private basicService: BasicService) {}

  async maybeOpenDateTimePopover(event) {
    if (!this.disabled) {
      const componentProps = {
        initialValue: this.value,
        withTime: this.withTime,
      };
      const popoverResult = await this.basicService.popoverWithResult(
        event,
        DatetimeIonicPopoverComponent,
        componentProps,
        'alc-datetime-popover'
      );
      if (popoverResult.role === ModalDismissRoleEnum.OK) {
        this.value = popoverResult.data as string;
        this.markAsTouched();
        this.onChange(this.value);
      }
    }
  }

  private markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  clear() {
    this.writeValue(null);
    this.onChange(null);
  }

  //
  // implementation of ControlValueAcccessor
  //

  writeValue(value: string) {
    this.value = value;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
}
